import React, { useEffect } from "react";
import { applySeoOverride } from "../hooks/useSeo";
import Header from "../components/Header";
import Hero from "../components/Hero";
import TrustFeatures from "../components/TrustFeatures";
import Categories from "../components/Categories";
import HowItWorks from "../components/HowItWorks";
import Benefits from "../components/Benefits";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "Find a Nanny, Babysitter & Housekeeper in the US | SimplySitter";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.setAttribute("content", "Find vetted nannies, babysitters, housekeepers & senior care across the US. Post your job free \u2014 interviewed & background-checked caregivers. 1 month free.");
    applySeoOverride();
    return () => { document.title = "SimplySitter"; };
  }, []);
  return (
    <div>
      <Header />
      <Hero />
      <TrustFeatures />
      <Categories />
      <HowItWorks />
      <Benefits />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
